module.exports = __webpack_public_path__ + "img/bespoke70_02.9d956c71.jpg";